import Vue from 'vue';
import Vuex from 'vuex';

import state from './store/state';
import * as actions from './store/actions';
import * as mutations from './store/mutations';
import * as getters from './store/getters';

import mail from './store/modules/mail';
import billing from './store/modules/billing';
import auth from './store/modules/auth';
import account from './store/modules/account';
import plans from './store/modules/plans';
import general from './store/modules/general';
import shipping from './store/modules/shipping';
import systems from './store/modules/systems';
import customers from './store/modules/customers';
import reports from './store/modules/reports';
import messages from './store/modules/messages';
import wrappers from './store/modules/wrappers';
import operators from './store/modules/operators';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    mail,
    auth,
    account,
    billing,
    plans,
    general,
    shipping,
    systems,
    customers,
    reports,
    messages,
    wrappers,
    operators
  },
});
